
import { useEffect } from "react";
import styled from "styled-components";
import Notice from "../../components/Notice";
import useGlobal from "../../hooks/useGlobal";
import EquipCard from "./components/EquipCard";
import Runway from "./components/Runway";
import SyncBtn from "./components/SyncBtn";
import SyncProcess from "./components/SyncProcess";
export default function Home() {
  const { canPlay, getAllInfo } = useGlobal();

  useEffect(() => {
    if (canPlay) {
      getAllInfo();
    }
  }, [canPlay]);
  return (
    <Wrapper>
      <Notice />
      <EquipCard />
      <Runway />
      {/* <SyncBtn /> */}
      <SyncProcess />
    </Wrapper>
  );
}


const Wrapper = styled.div`
padding-bottom:7.0rem;
`